import React from 'react';
import { connect } from 'react-redux';

import { users } from '../../../store/actions';

import LoginLink from './LoginLink';
import ProfileMenu from './ProfileMenu';
import Spinner from '../../Spinner/Spinner.js';

const UserControlDisplay = connect(state => ({ status: state.users.status }))(
  ({ status }) => {
    switch (status) {
      case users.types.GOT_DETAILS:
      case users.types.GOT_CREDITS:
      case users.types.PROMPTING_CHANGE_PASSWORD:
      case users.types.CHANGING_PASSWORD:
      case users.types.CHANGE_PASSWORD_FAILED:
      case users.types.CHANGE_PASSWORD:
      case users.types.GET_CREDITS_FAILED:
        return <ProfileMenu />;

      case users.types.LOGGED_OUT:
      case users.types.SHOW_LOGIN:
      case users.types.SHOW_REGISTER:
      case users.types.LOGIN_FAILED:
      case users.types.REGISTER_FAILED:
      case users.types.LOGGING_IN:
      case users.types.REGISTERING:
      case users.types.PROMPTING_RECOVERY_EMAIL:
      case users.types.SENDING_RECOVERY_EMAIL:
      case users.types.SENDING_RECOVERY_EMAIL_FAILED:
      case users.types.SENT_RECOVERY_EMAIL:
      case users.types.SETTING_NEW_PASSWORD:
      case users.types.SET_NEW_PASSWORD:
      case users.types.SETTING_NEW_PASSWORD_FAILED:
        return <LoginLink />;

      case users.types.LOGGED_IN:
      case users.types.GETTING_DETAILS:
        return (
          <div className="nav navbar-header navbar-right" width="10rem">
            <Spinner type="regular" />
          </div>
        );

      default:
        return null;
    }
  }
);

export default UserControlDisplay;



// WEBPACK FOOTER //
// ./src/comps/Navbar/components/UserControlDisplay.js